<div class="frameContainer" *ngIf="landscape; else portrait">
  <div class="headers" [style.width]="headerWidth">
    <div
      *ngFor="let c of contexts"
      class="frame"
      (click)="onToggleDetail(c.id)"
      [class.toggled]="openTab == c.id"
      [class.clickable]="!c.disabled"
      [hidden]="c.hidden"
    >
      <ng-container
        *ngTemplateOutlet="headerTemplate; context: c"
      ></ng-container>
    </div>
  </div>
  <div class="detailContainer" [class.open]="openTab" [style.width]="bodyWidth">
    <div class="detailWrapper" *ngIf="openTab">
      <ng-container
        *ngTemplateOutlet="bodyTemplate; context: currentContext"
      ></ng-container>
    </div>
  </div>
</div>
<ng-template #portrait>
  <div class="frameContainer portrait">
    <div *ngFor="let c of contexts">
      <div
        class="frame"
        (click)="onToggleDetail(c.id)"
        [class.toggled]="openTab == c.id"
        [class.clickable]="!c.disabled"
        [hidden]="c.hidden"
      >
        <ng-container
          *ngTemplateOutlet="headerTemplate; context: c"
        ></ng-container>
      </div>
      <div class="detailContainer open" *ngIf="openTab == c.id">
        <div class="detailWrapper">
          <ng-container
            *ngTemplateOutlet="bodyTemplate; context: c"
          ></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>
